import React, { useRef, useCallback, useEffect } from 'react';
import './Dashboard.less';
import { Icon } from 'antd';
import { useNavigate } from "react-router-dom";


type Props = {
    websiteGuid: string;
    strengths: string[];
    weaknesses: string[];
};


export default function StrengthsWeaknessesCard({ strengths, weaknesses, websiteGuid }: Props) {
    const navigate = useNavigate();
    const containerRef = useRef<HTMLDivElement | null>(null);
    const handleOnPageGroupClick = useCallback((event: MouseEvent) => {
        const target = event.target as HTMLElement;
        const pageGroupId = target.getAttribute('data-page-group-id');
        if (pageGroupId) {
            navigate(`/deep-analysis/page-group/?w_guid=${websiteGuid}&cluster_guid=${pageGroupId}`);
        }
    }, [navigate, websiteGuid]);


    useEffect(() => {
        const summaryEl = containerRef.current;
        if (!summaryEl) return;

        const spans = summaryEl.querySelectorAll<HTMLSpanElement>('.page-group-name');

        spans.forEach((span) => {
            span.addEventListener('click', handleOnPageGroupClick);
        });

        return () => {
            spans.forEach((span) => {
                span.removeEventListener('click', handleOnPageGroupClick);
            });
        };
    }, [handleOnPageGroupClick]);

    return (
        <div className='strengths-weaknesses-card' ref={containerRef}>
            <div className="strengths">
                <h4>Strengths</h4>
                <ul>
                    {strengths.map((strength, index) => (
                        <li
                            key={index}
                            className="item passed"
                        >
                            <Icon type="check" />
                            <span dangerouslySetInnerHTML={{ __html: strength }} />
                        </li>
                    ))}
                </ul>
            </div>
            <div className="weaknesses">
                <h4>Weaknesses</h4>
                <ul>
                    {weaknesses.map((weakness, index) => (
                        <li
                            key={index}
                            className="item warning"
                        >
                            <Icon type="warning" />
                            <span dangerouslySetInnerHTML={{ __html: weakness }} />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
